<template>
  <div class="flex justify-between items-center py-6">
    <div class="xs:mx-6 md:mx-8 lg:w-[750px] lg:mx-auto">
      <a :href="link" target="_blank" data-event-tracking="gensapp-home-cvp">
        <img :src="`${thumbnailImgMobile}`" class="md:hidden w-full" @click="registerAnalytics" />
        <img
          :src="`${thumbnailImgTablet}`"
          class="hidden w-full md:block"
          @click="registerAnalytics"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
export default {
  name: 'CVPCard',
  props: {
    link: {
      type: String,
    },
    thumbnailImgMobile: {
      type: String,
    },
    thumbnailImgTablet: {
      type: String,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    registerAnalytics() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'gensapp-home-cvp',
          page: 'home',
        },
      });
    },
  },
};
</script>

<style scoped></style>
